// extracted by mini-css-extract-plugin
module.exports = {"header__width":"styles_header__width__WnedN","header__sticky":"styles_header__sticky__jBpQM","header__button":"styles_header__button__t9Z8c"};